(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
	constructor() {
		super();
	}

	connectedCallback() {
		this.header = document.querySelector('.shopify-section-header');
		this.headerWrapper = document.querySelector('.header-wrapper');
		this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
		this.headerBounds = {};
		this.currentScrollTop = 0;
		this.preventReveal = false;
		this.predictiveSearch = this.querySelector('predictive-search');
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme') || "";
		this.isLightLogo = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-light-logo') || "";

		this.onScrollHandler = this.onScroll.bind(this);
		this.hideHeaderOnScrollUp = () => this.preventReveal = true;

		this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.addEventListener('scroll', this.onScrollHandler, false);

		this.createObserver();

		if (this.isLightLogo == 'true')
			this.header.classList.add('header--light-logo');
		else 
			this.header.classList.remove('header--light-logo');
	}

	disableScroll() {
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	enableScroll() {
		window.addEventListener('scroll', this.onScrollHandler, false);
	}

	disconnectedCallback() {
		this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
		window.removeEventListener('scroll', this.onScrollHandler);
	}

	createObserver() {
		let observer = new IntersectionObserver((entries, observer) => {
		this.headerBounds = entries[0].intersectionRect;
		observer.disconnect();
		});

		if (this.header) {
			observer.observe(this.header);
		}
	}

	onScroll() {
		const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		
		if (this.headerIsAlwaysSticky) {
			if (this.header.classList.contains("color-background-overlay")) {
				if (scrollTop > this.header.offsetHeight + 1) {
					this.header.classList.remove('color-background-overlay');
					/*if (this.colorScheme)
						this.header.classList.remove(this.colorScheme);*/
					this.header.classList.forEach(className => {
						if (className.startsWith('color-background-') && className != 'color-background-overlay') {
							this.header.classList.remove(className);
						}
					});
					this.header.classList.add('shopify-section-header-scroll');
					this.header.classList.add('color-background-overlay-hidden');
				};
			};

			if (this.header.classList.contains('color-background-overlay-hidden')) {
				if (scrollTop < this.header.offsetHeight) {
					this.header.classList.add('color-background-overlay');
					if (this.colorScheme)
						this.header.classList.add(this.colorScheme);	
					this.header.classList.remove('shopify-section-header-scroll');
					this.header.classList.remove('color-background-overlay-hidden');
				};
			};
		}

		if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (this.preventHide) return;
			requestAnimationFrame(this.hide.bind(this));
		} else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
			if (!this.preventReveal) {
				requestAnimationFrame(this.reveal.bind(this));
			} else {
				window.clearTimeout(this.isScrolling);

				this.isScrolling = setTimeout(() => {
					this.preventReveal = false;
				}, 66);

				requestAnimationFrame(this.hide.bind(this));
			}
		} else if (scrollTop <= this.headerBounds.top) {
			requestAnimationFrame(this.reset.bind(this));
		}

		this.currentScrollTop = scrollTop;
	}

	hide() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
		this.closeMenuDisclosure();
	}

	reveal() {
		if (this.headerIsAlwaysSticky) {
			this.header.classList.add('shopify-section-header-scroll')
			return;
		}
		this.header.classList.add('shopify-section-header-sticky', 'animate');
		this.header.classList.remove('shopify-section-header-hidden');

		if (this.header.classList.contains('color-background-overlay')) {
			this.header.classList.remove('color-background-overlay');
			/*if (this.colorScheme)
				this.header.classList.remove(this.colorScheme);*/
			this.header.classList.forEach(className => {
				if (className.startsWith('color-background-') && className != 'color-background-overlay') {
					this.header.classList.remove(className);
				}
			});
			this.header.classList.add('color-background-overlay-hidden');
		}
	}

	reset() {
		this.colorScheme = document.querySelector('main').querySelectorAll('.shopify-section')[0]?.querySelector('[data-header-transparent]')?.getAttribute('data-header-transparent-color-scheme');
		if (this.headerIsAlwaysSticky) {
			this.header.classList.remove('shopify-section-header-scroll')
			return;
		}
		this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');

		if (this.header.classList.contains('color-background-overlay-hidden')) {
			this.header.classList.add('color-background-overlay');
			if (this.colorScheme)
				this.header.classList.add(this.colorScheme);
			this.header.classList.remove('color-background-overlay-hidden');
		}
	}

	closeMenuDisclosure() {
		this.disclosures = this.disclosures || this.header.querySelectorAll('details-disclosure');
		if (typeof DetailsDisclosure !== 'undefined') {
			this.disclosures.forEach((disclosure) => {
				disclosure.close();
			});
		}
		this.disclosureLists = this.header.querySelectorAll('.disclosure__list');
			this.disclosureLists.forEach((disclosureList) => {
				disclosureList.setAttribute('hidden', true); 
			});
		}
	}

	customElements.define('sticky-header', StickyHeader);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  class GiftNote extends HTMLElement {
    constructor() {
      super();

      this.toggleBtn = this.querySelector('[data-gift-toggle]');
      this.fieldsWrap = this.querySelector('[data-gift-fields]');
      this.hiddenNote = this.querySelector('#Cart-note');
      this.inputs = this.querySelectorAll('[data-gift-field]');

      // 1) восстановление из cart.note (если уже было заполнено ранее)
      this.restoreFromExistingNote();

      // 2) железно выставляем стартовое состояние (на случай если тема ломает hidden)
      this.syncUIState();

      // 3) кнопка раскрытия
      this.toggleBtn?.addEventListener('click', () => {
        const willOpen = this.fieldsWrap.hidden; // если скрыто — откроем
        this.fieldsWrap.hidden = !willOpen;

        this.toggleBtn.classList.toggle('is-active', willOpen);
        this.toggleBtn.setAttribute('aria-expanded', String(willOpen));
        this.toggleBtn.textContent = willOpen ? 'Gift details added' : 'Send as a gift';

        this.syncNote();
      });

      // 4) обновление note на ввод
      const onInput = debounce(() => this.syncNote(), 300);
      this.inputs.forEach((el) => el.addEventListener('input', onInput));
    }

    syncUIState() {
      const isOpen = !this.fieldsWrap.hidden;
      this.toggleBtn?.classList.toggle('is-active', isOpen);
      this.toggleBtn?.setAttribute('aria-expanded', String(isOpen));
      if (this.toggleBtn) {
        this.toggleBtn.textContent = isOpen ? 'Gift details added' : 'Send as a gift';
      }
    }

    buildNoteText() {
      // если блок закрыт — считаем, что gift не включён
      if (this.fieldsWrap.hidden) return '';

      const getVal = (key) => {
        const el = this.querySelector(`[data-gift-field="${key}"]`);
        return (el?.value || '').trim();
      };

      const recipientName = getVal('recipient_name');
      const recipientPhone = getVal('recipient_phone');
      const recipientAddress = getVal('recipient_address');
      const cardMessage = getVal('card_message');
      const deliveryNotes = getVal('delivery_notes');

      const lines = [
        'Gift order: Yes',
        `Recipient name: ${recipientName}`,
        `Recipient phone: ${recipientPhone}`,
        `Delivery address: ${recipientAddress}`,
      ];

      if (cardMessage) lines.push(`Card message: ${cardMessage}`);
      if (deliveryNotes) lines.push(`Delivery notes: ${deliveryNotes}`);

      return lines.join('\n');
    }

    async syncNote() {
      const noteText = this.buildNoteText();

      // sync hidden textarea
      if (this.hiddenNote) this.hiddenNote.value = noteText;

      try {
        const body = JSON.stringify({ note: noteText });
        await fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } });
      } catch (e) {
        // никогда не блокируем checkout
      }
    }

    restoreFromExistingNote() {
      const existing = (this.hiddenNote?.value || '').trim();
      if (!existing) return;

      // если это не наш формат — не трогаем
      if (!existing.includes('Gift order: Yes')) return;

      // раскрываем блок
      this.fieldsWrap.hidden = false;

      const mapLine = (label) => {
        const line = existing.split('\n').find((l) => l.startsWith(label));
        return line ? line.replace(label, '').trim() : '';
      };

      const setVal = (key, val) => {
        const el = this.querySelector(`[data-gift-field="${key}"]`);
        if (el) el.value = val || '';
      };

      setVal('recipient_name', mapLine('Recipient name:'));
      setVal('recipient_phone', mapLine('Recipient phone:'));
      setVal('recipient_address', mapLine('Delivery address:'));
      setVal('card_message', mapLine('Card message:'));
      setVal('delivery_notes', mapLine('Delivery notes:'));
    }
  }

  customElements.define('gift-note', GiftNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  class ProductModal extends ModalDialog {
    constructor() {
      super();
    }

    hide() {
      super.hide();
      window.pauseAllMedia();
    }

    show(opener) {
      super.show(opener);
      this.showActiveMedia();
    }

    showActiveMedia() {
      const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);

      if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMedia.querySelector('template')?.content?.querySelector('.js-youtube')) {
        activeMedia.loadContent();
      }
    }
  }

  customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();
})();
